// extracted by mini-css-extract-plugin
export default {"btn":"NavigationButton_btn__2EC1Q","sm":"NavigationButton_sm__JcDQf","watchOverflow":"NavigationButton_watchOverflow__7z2Fa","reverse":"NavigationButton_reverse__B5ioU"};